import { render } from "./member.vue?vue&type=template&id=11dcd10c&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"

import "./member.vue?vue&type=style&index=0&id=11dcd10c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11dcd10c"]])

export default __exports__